export default function destroyExportProgress(state, { id }) {
  return Object.assign({}, state, {
    exports: state.exports.filter(e => e.id !== id)
  })
}



// WEBPACK FOOTER //
// ./src/reducers/destroyExportProgress.js